import React from 'react';
import './Pvcpipefittable.css';


const Pvcpipefittable = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">PVC Pipe Fitting Injection Production with Powerjet PVC330</h2>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Machine Model</strong> </p>
                    <p><strong>Clamping Force</strong> </p>
                    <p><strong>Opening Stroke</strong></p>
                    <p><strong>Ejector Stroke</strong></p>
                    <p><strong>Ejector Force</strong></p>
                    <p><strong>Screw Stroke</strong></p>

                </div>
                <div className="right-column">
                    <p>	PVC330-S6</p>
                    <p>330kN</p>
                    <p>600mm</p>
                    <p>180mm</p>
                    <p>77mm</p>
                    <p>310mm</p>
                </div>
            </div>
        </div>
    );
};

export default Pvcpipefittable;
